import type { DefecationEntity } from './entity/defecationEntity';
import type { DefecationIRepository } from './entity/defecationIRepository';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * 排泄ドメインサービス
 */
export class DefecationDomainService extends DomainServiceBase {
  private defecationRepository!: DefecationIRepository;

  /**
   * Injection
   * @param defecationRepository defecationRepository
   */
  public inject(
    defecationRepository: DefecationIRepository,
  ) {
    this.defecationRepository = defecationRepository;
  }

  /**
   * 排泄リスト取得
   * @param token トークン
   * @returns リスト
   */
  async getDefecationList(token: string | null) {
    const result = await this.defecationRepository.getList(token);
    const { nextToken } = result;
    const items = result.items.map((v: DefecationEntity) => v.toJson());
    return {
      /** 次のトークン */
      nextToken,
      /** アイテムリスト */
      items,
    };
  }

  /**
   * 指定日の排泄リスト取得
   * @param date 日付
   * @returns リスト
   */
  async getDefecationListWithDate(date: string) {
    const result = await this.defecationRepository.getAllListWithKey(date);
    const items = result.map((v: DefecationEntity) => v.toJson());
    return items;
  }

  /**
   * createDefecation
   * @param entity 入力
   * @returns 結果
   */
  async createDefecation(
    entity: DefecationEntity,
  ) {
    const result = await this.defecationRepository.create(entity);
    return result;
  }

  /**
   * updateDefecation
   * @param entity 入力
   * @returns 結果
   */
  async updateDefecation(
    entity: DefecationEntity,
  ) {
    const result = await this.defecationRepository.update(entity);
    return result;
  }

  /**
   * deleteDefecation
   * @param entity 入力
   * @returns 結果
   */
  async deleteDefecation(
    entity: DefecationEntity,
  ) {
    const result = await this.defecationRepository.delete(entity);
    return result;
  }
}
